export default "/_next/static/images/face358c9972967f54ba4b1dd0be5ae3.png";